import * as apiDiaLetivoExtra from "../DiaLetivoExtra/api-dia-letivo-extra";
import * as apiDiaLetivoExtraSerie from "../DiaLetivoExtraSerie/api-dia-letivo-extra-serie";
import * as apiDiaNaoLetivo from "../DiaNaoLetivo/api-dia-nao-letivo";
import * as apiDiaNaoLetivoSerie from "../DiaNaoLetivoSerie/api-dia-nao-letivo-serie";

/**
 * Os módulos de Dia Letivo Extra e Dia Não Letivo são idênticos; muda só a API,
 * os textos e o nome do campo usado no vínculo com a série.
 */
export const DIA_LETIVO_EXTRA = {
  plural: "Dias Letivos Extras",
  singular: "Dia Letivo Extra",
  descricao: "Dias que contam como letivos fora do calendário normal (ex.: sábados letivos).",
  campoSerie: "diaLetivoExtra",
  api: apiDiaLetivoExtra,
  apiSerie: apiDiaLetivoExtraSerie,
};

export const DIA_NAO_LETIVO = {
  plural: "Dias Não Letivos",
  singular: "Dia Não Letivo",
  descricao: "Feriados, recessos e outros dias sem aula.",
  campoSerie: "diaNaoLetivo",
  api: apiDiaNaoLetivo,
  apiSerie: apiDiaNaoLetivoSerie,
};
